import classnames from 'classnames/bind';
import { RtList } from '@dpa/react-item';
import { TResponseDataToOptions } from '../../_utils/transform-response-data-to-options/_types';
import { DropdownOption } from './_components/dropdown-option';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Dropdown-options';

type TProps = {
  options: Array<TResponseDataToOptions>;
  searchingText: string;
  onChange: (value: TResponseDataToOptions) => void;
};

export const DropdownOptions = ({
  options,
  searchingText,
  onChange,
}: TProps) => {
  const renderCustomOption = (option: TResponseDataToOptions) => (
    <DropdownOption
      option={option}
      searchingText={searchingText}
      onChange={onChange}
    />
  );

  return (
    <div className={cn(BLOCK_NAME)}>
      <RtList
        useGrid
        use="achromatic-cloudy"
        items={options}
        getId={(option) => option.id}
        renderItem={renderCustomOption}
      />
    </div>
  );
};
